(function() {
    'use strict';
    
a3_cabin_reports.service("CabinAPIService", CabinAPIService)
   
    /**
    * @memberof CabinReports
    * @ngdoc service
    * @name CabinAPIService
    * @description 
    *   Api login service
    * @ngInject
    */
    function CabinAPIService($http, $q, apiUrl) {
		return {
				  /**
			   * Login to Pilot Api
			   * @memberof PilotAPIService
			   * @param {number} username
			   * @returns {string} password
			   */
		  login: function(token) {
			var call = $q.defer();
			var bearer = "Bearer " + token;
  
			$http.post(apiUrl +'/login',{},{'headers':{'Content-Type': 'application/json','Authorization':bearer}})
			
			.then(
				function(responseData) {
				  call.resolve(responseData);
				},
				function(err) {
				  call.reject(err);
				}
			);
			return call.promise;
		  }
		}
	  }

})();